import { AppRouteCreators } from '../types/core'
import { EnumLiteralsOf } from '../types/helpers'

const PageNames = {
  dashboard: 'citations dash',
  bibliography: 'bibliography',
  search: 'search',
  searchResults: 'citation search results',
  form: 'citation form',
} as const

export const pageSubGroupMap = {
  eval: 'citation evaluation review',
  form: 'citation form',
  searchresults: 'citation search results',
  view: 'bibliography',
} as const

type PageName = EnumLiteralsOf<typeof PageNames>
type RouteToPageNameMap = Partial<Record<keyof AppRouteCreators, PageName>>

export const routeToPageNameMap: RouteToPageNameMap = {
  toCitationsDashboard: PageNames.dashboard,
  toCitationList: PageNames.bibliography,
  toCitationListSource: PageNames.search,
  toCitationListForm: PageNames.form,
} as const

export const getSubdomain = (hostname: string) => {
  const segments = hostname.split('.')
  const subdomain = segments.length < 3 ? 'www' : segments[0]
  return subdomain
}

export const sendToGTM = (data) => {
  if (typeof window !== 'undefined') {
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
      ...data,
    })
  }
}
